import { render, staticRenderFns } from "./RecipientsComponent.vue?vue&type=template&id=077d6a4c&"
import script from "./RecipientsComponent.vue?vue&type=script&lang=js&"
export * from "./RecipientsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports